import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { renderRichText } from "@/components/common/rich-text";

// Retention periods table for 제3조
const RETENTION_TABLE = {
  headers: ["구분", "보유기간"],
  rows: [
    {
      label: "수요자·공급자(외부 이용자) 회원정보 및 이용기록",
      value:
        "회원 탈퇴 시 또는 관련 Engagement 종료 시까지. 다만 안정적인 서비스 제공 및 분쟁 대응을 위하여 휴면(비활성) 계정 전환 후 3년간 보유할 수 있습니다.",
    },
    {
      label: "PwC 직원 고유 ID(GUID) 등 임직원 개인정보",
      value: "퇴직 시로부터 10년",
    },
    {
      label: "프로젝트 요구사항 리포트·문의 티켓 내 개인정보",
      value: "해당 이용자의 계정 만료 시 또는 관련 Engagement 종료 시까지",
    },
    {
      label: "접속 로그 등 자동수집정보",
      value: "「통신비밀보호법」 등 관계 법령에서 정한 기간",
    },
  ],
};

// Overseas transfer table for 제5조의2
const OVERSEAS_TRANSFER_TABLE = {
  headers: ["이전받는 자", "이전 국가", "이전 항목 · 목적 · 시기 및 방법 · 보유기간"],
  rows: [
    {
      label: "PwC IT Services Limited (PwC Network)",
      country: "영국, 싱가포르 등",
      value:
        "[항목] 임직원 정보(성명, 이메일, 직급 등), 이용자가 제공한 Contact 정보 등 / [목적] 효율적 업무 수행, IT 통합·운영 관리, 정보보안 / [시기·방법] 수시, 정보통신망을 통한 전송 / [보유기간] 수집 목적 달성 시 또는 삭제 요청 시까지",
    },
    {
      label: "Google, Microsoft, Amazon Web Services",
      country: "미국, 벨기에, 캐나다, 영국 등",
      value:
        "[항목] 이용자 정보, Contact 정보 등(클라우드 호스팅 과정에서 처리) / [목적] 효율적 업무 수행, 서비스 제공을 위한 클라우드 인프라(GCP, Azure, AWS) 운영 / [시기·방법] 수시, 정보통신망을 통한 전송 / [보유기간] 수집 목적 달성 시 또는 삭제 요청 시까지",
    },
  ],
};

// Privacy policy sections (제1조 ~ 제12조)
const SECTIONS = [
  {
    title: "제1조(수집하는 개인정보의 항목)",
    content: [
      {
        type: "paragraph" as const,
        text: "① 회사는 플랫폼 서비스의 제공을 위하여 다음과 같은 개인정보를 수집합니다.\n1. 회원가입 및 서비스 이용 과정에서의 수집\n  • **수요자(Demander)**: 성명(담당자명), 회사 이메일, 연락처, 회사명, 종사 분야(Industry), 도입을 희망하는 AI 종류, 소속 부서·직위/직함\n  • **공급자(Provider)**: 성명(담당자명), 회사 이메일, 연락처, 회사명, 회사 홈페이지, 임직원 규모, 자금 조달 단계, 회사 소재지, 최근 회계연도 매출액 범위, 회사 유형, 직위/직함, 보유 보안 및 컴플라이언스 인증, 누적 도입 고객사 규모 및 대표 고객사 정보, 등록 AI 솔루션 정보(제품·서비스명, 유형, 출시 상태, 기능·효과 설명, 분류 및 도메인, 솔루션 적용 사례, 지원 데이터 모달리티 종류, 배포·운영 방식, 제공 인터페이스, 체험·PoC 정보, 과금 모델 및 도입 비용대)\n  • **관리자 및 내부 이용자(PwC컨설팅 임직원)**: PwC 직원 고유 ID(GUID), 사용자 ID, 사내 이메일, 직급\n2. 인증 과정에서의 수집\n  • 마이크로소프트 Entra ID 기반 B2B Guest 인증에 수반되는 계정 식별정보(이메일 계정, 인증 식별자)\n3. 서비스 이용 과정에서 이용자가 입력·생성하는 정보\n  • 프로젝트 요구사항 정보 및 리포트(AX 프로젝트를 위한 문제상황·요구사항 정의 내용), 문의 티켓(에이전트 등록 문의 및 이슈 문의 내용)에 포함된 개인정보\n4. 서비스 이용 과정에서 자동으로 생성·수집되는 정보\n  • 접속 로그, 접속 IP 정보, 쿠키, 서비스 이용기록, 기기·브라우저 정보\n② 회사는 사상·신념, 건강, 정치적 견해 등 「개인정보 보호법」 제23조에 따른 민감정보 및 고유식별정보를 원칙적으로 수집하지 아니합니다.",
      },
    ],
  },
  {
    title: "제2조(개인정보의 이용목적)",
    content: [
      {
        type: "paragraph" as const,
        text: "회사가 처리하는 개인정보는 다음의 목적 이외의 용도로는 이용되지 아니하며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.\n① 회원가입 의사 확인, 이용자 식별·인증 및 회원 자격 유지·관리\n② AI 솔루션 도입 수요의 진단, 요구사항의 정의 및 수요자와 공급자 간의 매칭·추천 서비스 제공\n③ 공급자가 등록한 AI 솔루션 정보의 검토·노출 및 매칭 풀 관리\n④ PoC, 운영·통합, 비즈니스 확산 등 컨설팅 연계 서비스의 제공 및 PwC 컨설팅 사업기회의 발굴\n⑤ 문의·이슈 접수 및 처리, 고객 응대 및 분쟁 조정을 위한 기록 보존\n⑥ 서비스의 안정적 운영, 보안 관리, 부정이용 방지 및 서비스 개선\n⑦ 공지사항 전달, 관계 법령 및 본 방침에 따른 의무 이행",
      },
    ],
  },
  {
    title: "제3조(개인정보의 처리 및 보유기간)",
    content: [
      {
        type: "paragraph" as const,
        text: "① 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집할 때 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.\n② 각각의 개인정보 처리 및 보유기간은 다음과 같습니다.",
      },
      { type: "retention_table" as const },
      {
        type: "paragraph" as const,
        text: "③ 회사는 다른 법령에서 일정 기간 보존의무를 부과하는 경우 해당 법령에서 정한 기간 동안 개인정보를 보관하며, 이 경우 보관하는 개인정보는 그 보존 목적으로만 이용합니다.",
      },
    ],
  },
  {
    title: "제4조(개인정보의 제3자 제공)",
    content: [
      {
        type: "paragraph" as const,
        text: "① 회사는 정보주체의 개인정보를 제2조(개인정보의 이용목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. 다만, 사전에 동의한 경우 및 관련 법령에 따라 적법한 절차에 의한 정부·수사기관의 요청이 있는 경우 등 법에 의하여 요구된다고 선의로 판단되는 경우는 예외로 합니다.\n② 플랫폼의 매칭 서비스 특성상, 수요자와 공급자 간 연결을 위하여 필요한 범위에서 일방 당사자의 정보(담당자 연락처, 회사명, 요구사항 또는 AI 솔루션 정보 등)가 상대방에게 제공될 수 있으며, 회사는 이러한 제공이 이루어지는 경우 그 항목과 목적을 사전에 고지하고 동의를 받습니다.",
      },
    ],
  },
  {
    title: "제5조(개인정보 처리의 위탁)",
    content: [
      {
        type: "paragraph" as const,
        text: "회사는 수집된 개인정보를 제2조에서 고지한 범위 내에서 직접 처리하며, 원칙적으로 정보주체의 개인정보 처리를 제3자에게 위탁하지 아니합니다. 향후 원활한 서비스 제공을 위하여 개인정보 처리업무의 위탁이 필요한 경우, 회사는 「개인정보 보호법」 제26조에 따라 위탁받는 자(수탁자)와 위탁하는 업무의 내용을 본 개인정보 처리방침을 통하여 사전에 공개하고, 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하겠습니다.",
      },
    ],
  },
  {
    title: "제5조의2(개인정보 처리위탁 중 국외 이전에 관한 사항)",
    content: [
      {
        type: "paragraph" as const,
        text: "회사는 효율적인 업무 수행 및 서비스 제공을 위하여 아래와 같이 개인정보의 처리를 국외에 위탁하고 있습니다. 정보주체는 개인정보의 국외이전을 거부할 수 있으며, 거부를 원하시는 경우 본 방침 제10조에 기재된 연락처로 연락주시기 바랍니다. 다만 국외이전을 거부하실 경우 서비스의 제공이 제한될 수 있습니다.",
      },
      { type: "overseas_transfer_table" as const },
    ],
  },
  {
    title: "제6조(정보주체의 권리·의무 및 행사방법)",
    content: [
      {
        type: "paragraph" as const,
        text: "① 정보주체는 회사에 대하여 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.\n1. 개인정보 열람 요구\n2. 오류 등이 있을 경우 정정 요구\n3. 삭제 요구\n4. 처리정지 요구\n② 제1항에 따른 권리 행사는 회사에 대하여 「개인정보 처리 방법에 관한 고시」 별지 제8호 및 제10호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대하여 지체 없이 조치하겠습니다.\n③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우 회사는 정정 또는 삭제를 완료할 때까지 해당 개인정보를 이용하거나 제공하지 아니합니다.\n④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있으며, 이 경우 「개인정보 처리 방법에 관한 고시」 별지 제11호 서식에 따른 위임장을 제출하여야 합니다.\n⑤ 공급자가 등록한 AI Agent 및 솔루션 정보의 등록·수정·삭제는 본인 확인 후 회사의 승인 절차를 거쳐 처리되며, 정보주체 본인의 개인정보에 대한 권리 행사는 본조에 따라 보장됩니다.",
      },
    ],
  },
  {
    title: "제7조(개인정보의 파기)",
    content: [
      {
        type: "paragraph" as const,
        text: "① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다. 플랫폼은 관련 계정의 만료 또는 Engagement 종료가 트리거되는 경우 시스템에서 관련 정보를 자동으로 삭제하도록 설정되어 있습니다.\n② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존합니다.\n③ 회사는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.",
      },
    ],
  },
  {
    title: "제8조(개인정보의 안전성 확보조치)",
    content: [
      {
        type: "paragraph" as const,
        text: "회사는 개인정보의 안전성 확보를 위하여 다음과 같은 조치를 취하고 있습니다.\n• **관리적 조치**: 내부관리계획 수립·시행, 정기적 직원 교육, 접근권한자 최소화 및 운영계정·개인계정의 분리 운영\n• **기술적 조치**: 개인정보처리시스템에 대한 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치, 접속기록의 보관 및 위·변조 방지\n• **물리적 조치**: 전산실·자료보관실 등에 대한 접근통제",
      },
    ],
  },
  {
    title: "제9조(개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항)",
    content: [
      {
        type: "paragraph" as const,
        text: "회사의 웹사이트에서 Google Analytics 기능을 활용하는 경우 Google이 쿠키 정보를 수집·처리할 수 있습니다. 이용자는 아래와 같이 쿠키의 설치·운영을 거부할 수 있습니다.\n회사는 이용자에게 최적화된 서비스를 제공하기 위하여 이용자의 정보를 수시로 저장하고 불러오는 '쿠키(cookie)'를 운용할 수 있습니다. 쿠키는 웹사이트 서버가 이용자의 브라우저에 보내는 소량의 텍스트 파일로서 이용자의 단말기에 저장될 수 있습니다.\n① 쿠키의 사용 목적: 이용자의 접속 유지, 이용 환경 설정, 서비스 이용 분석을 통한 최적화된 정보 제공\n② 쿠키의 설치·운영 및 거부: 이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 메뉴에서 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 다만 쿠키 저장을 거부할 경우 일부 서비스의 이용에 제한이 있을 수 있습니다.",
      },
    ],
  },
  {
    title: "제10조(개인정보 보호책임자)",
    content: [
      {
        type: "paragraph" as const,
        text: "① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.\n• **개인정보 보호책임자**: 정보보호회장\n• **개인정보 보호 담당부서**: 정보보호위원회\n• **전화번호**: 02-3781-3111 / **이메일**: kr_pwcc@pwc.com\n② 정보주체는 회사의 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있으며, 회사는 정보주체의 문의에 대하여 지체 없이 답변 및 처리하겠습니다.",
      },
    ],
  },
  {
    title: "제11조(권익침해 구제방법)",
    content: [
      {
        type: "paragraph" as const,
        text: "① 정보주체는 개인정보 침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 그 밖에 개인정보 침해의 신고·상담에 대하여는 아래 기관에 문의하시기 바랍니다.\n• **개인정보분쟁조정위원회**: (국번없이) 1833-6972 (www.kopico.go.kr)\n• **개인정보침해신고센터**: (국번없이) 118 (privacy.kisa.or.kr)\n• **대검찰청**: (국번없이) 1301 (www.spo.go.kr)\n• **경찰청**: (국번없이) 182 (ecrm.cyber.go.kr)\n② 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.\n• **중앙행정심판위원회**: (국번없이) 110 (www.simpan.go.kr)",
      },
    ],
  },
  {
    title: "제12조(개인정보 처리방침의 변경)",
    content: [
      {
        type: "paragraph" as const,
        text: "① 이 개인정보 처리방침은 2025년 6월 17일부터 적용됩니다.\n② 개인정보 처리방침에 변경이 있는 경우에는 변경사항의 시행 7일 전부터 플랫폼을 통하여 공지하며, 이용자에게 불리한 변경의 경우에는 30일 전부터 공지합니다. 기존 개인정보 처리방침은 별도의 링크를 통하여 확인하실 수 있습니다.",
      },
    ],
  },
];

export const PrivacyPage = () => {
  return (
    <div className="px-5 py-10 lg:px-[100px] lg:py-10 flex flex-col gap-12 lg:max-w-[1240px] mx-auto">
      {/* Page Header */}
      <div className="flex flex-col gap-2 lg:gap-3">
        <h1 className="text-[44px] leading-[48px] tracking-[-0.0318em] lg:text-[56px] lg:leading-[64px] lg:tracking-[-0.03em] font-normal text-black text-center">
          개인정보 처리방침
        </h1>
        <span className="text-base leading-6 tracking-[-0.01em] text-black text-center">
          프라이스워터하우스쿠퍼스컨설팅
        </span>
      </div>

      {/* Intro paragraph */}
      <p className="text-base leading-6 tracking-[-0.01em] text-black">
        프라이스워터하우스쿠퍼스컨설팅(이하 &lsquo;PwC컨설팅&rsquo; 또는 &lsquo;회사&rsquo;)은
        「개인정보 보호법」 제30조 및 관계 법령에 따라 정보주체의 개인정보를 보호하고 이와 관련한
        고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을
        수립·공개합니다.
      </p>

      {/* Sections */}
      <div className="flex flex-col gap-6">
        {SECTIONS.map((section) => (
          <div key={section.title} className="flex flex-col gap-3">
            <h2 className="text-2xl leading-7 lg:leading-8 tracking-[-0.0183em] lg:tracking-[-0.02em] font-bold text-black">
              {section.title}
            </h2>
            {section.content.map((item, idx) => {
              if (item.type === "paragraph") {
                return (
                  <ul key={idx} className="flex flex-col gap-2">
                    {item.text.split("\n").map((line, lIdx) => {
                      const trimmedLine = line.trimStart();
                      const isBullet = trimmedLine.startsWith("•");

                      if (isBullet) {
                        return (
                          <li
                            key={lIdx}
                            className="flex text-base leading-6 tracking-[-0.01em] text-black pl-[10px] font-normal"
                          >
                            <span className="mr-[6px]">•</span>
                            <div className="flex-1">
                              {renderRichText(trimmedLine.substring(1).trimStart())}
                            </div>
                          </li>
                        );
                      }

                      return (
                        <li
                          key={lIdx}
                          className="text-base leading-6 tracking-[-0.01em] text-black font-normal"
                        >
                          {renderRichText(line)}
                        </li>
                      );
                    })}
                  </ul>
                );
              }
              if (item.type === "retention_table") {
                return (
                  <div key={idx} className="rounded-md border border-black/[0.15] overflow-hidden">
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-[#EBEBEB]">
                          {RETENTION_TABLE.headers.map((header) => (
                            <TableHead
                              key={header}
                              className="text-xs uppercase tracking-normal text-black font-normal h-12"
                            >
                              {header}
                            </TableHead>
                          ))}
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {RETENTION_TABLE.rows.map((row) => (
                          <TableRow key={row.label} className="">
                            <TableCell className="w-[175px] lg:w-[433px] text-black p-3 text-[16px]">
                              {row.label}
                            </TableCell>
                            <TableCell className="text-black p-3 text-[16px]">
                              {row.value}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                );
              }
              if (item.type === "overseas_transfer_table") {
                return (
                  <div key={idx} className="rounded-md border border-black/[0.15] overflow-hidden">
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-[#EBEBEB] hover:bg-[#EBEBEB]">
                          {OVERSEAS_TRANSFER_TABLE.headers.map((header) => (
                            <TableHead
                              key={header}
                              className="text-xs uppercase tracking-normal text-black font-normal h-12"
                            >
                              {header}
                            </TableHead>
                          ))}
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {OVERSEAS_TRANSFER_TABLE.rows.map((row) => (
                          <TableRow key={row.label}>
                            <TableCell className="w-[25%] p-3 text-[16px] text-black">
                              {row.label}
                            </TableCell>
                            <TableCell className="w-[20%] p-3 text-[16px] text-black">
                              {row.country}
                            </TableCell>
                            <TableCell className=" p-3 text-[16px] text-black">
                              {row.value}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                );
              }
              return null;
            })}
          </div>
        ))}
      </div>
    </div>
  );
};
